<style scoped lang="scss">
    h4 {
        margin: 0;
    }
    .select-wrapper {
        label {
            padding-left: 10px;
        }
        input {
            margin-left: 20px;
        }
    }
    .info-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        label {
            display: inline-block;
            width: 330px;
        }
        .text-input {
            width: 265px;
        }
    }
    table {
        tr {
            border-bottom: 1px dashed #efefef;
        }
    }
</style>

<template>
    <div class="uk-width-1-1 uk-grid">
        <header-row></header-row>
        <div class="uk-width-1-1">
            <h4>Household Member's Name: {{ fullName }}</h4>
            <h4>Property Address: {{ propertyAddress }}</h4>
        </div>
        <div class="uk-width-1-1 uk-margin-top">
            <p><b>Within the last 12 months, did you receive income from any of the following sources?</b></p>
            <table class="uk-table uk-hidden-small">
                <thead>
                <tr>
                    <th>Income Type</th>
                    <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, idx) in incomes">
                    <td width="70%">{{ item.label }}</td>
                    <td>{{ item.val ? 'Yes': 'No' }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="html2pdf__page-break"></div>

        <header-row></header-row>

        <div class="uk-width-1-1 uk-margin-large-top">
            <p>Under penalty of perjury, I certify that the information presented in this certification is true and accurate to the best of my knowledge.  I further understand that providing false representations constitutes an act of fraud. False, misleading, or incomplete information may result in the repayment of any funds received through the <b>{{ program['program_abbreviation'] }}</b> Program and other remedies available under applicable law.  I also give the <b>{{ program['agency_short_name'] }}</b> and its partners permission to obtain a copy of any tax returns from the Internal Revenue Service and to verify income and other information provided herein from other State agencies.</p>
        </div>

        <div class="uk-width-1-1">
            <signatures label="Printed Name of Household Member"></signatures>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from "vuex";
    import ApplicantData from "../Partials/ApplicantData";
    import ApplicantIncome from "../Partials/ApplicantIncome";
    import HeaderRow from "../Partials/HeaderRow";
    import ReviewResults from "../Partials/ReviewResults";
    import AttachedDocuments from "../Partials/AttachedDocuments";
    import BlankPage from "../Partials/BlankPage";
    import PrintableSignature from "../Partials/PrintableSignature";
    import Signatures from "../Partials/Signatures";

    export default {
        name: "NoIncomeHHAttestation",
        props: {
            member: {
                type: Object,
                default: {},
            }
        },
        data() {
            return {
                incomes: [
                    {
                        id: 'wages',
                        label: 'Wages, salaries, tips, bonus, commissions, etc.',
                        val: false
                    },
                    {
                        id: 'service_pay',
                        label: 'Severance pay',
                        val: false
                    },
                    {
                        id: 'worker-compensation',
                        label: 'Worker’s compensation',
                        val: false
                    },
                    {
                        id: 'interest',
                        label: 'Interest/dividends from assets, including bank accounts',
                        val: false
                    },
                    {
                        id: 'net-income',
                        label: 'Net income from the Operation of a Business or Profession',
                        val: false
                    },
                    {
                        id: 'self-employment',
                        label: 'Income from Self-employment, including direct sales consulting (i.e. Mary Kay, Tupperware), Uber/Lyft services, and online sales',
                        val: false
                    },
                    {
                        id: 'unemployment-benefit',
                        label: 'Unemployment benefits',
                        val: false
                    },
                    {
                        id: 'ssi',
                        label: 'Social Security or Supplemental Security Income (SSI)',
                        val: false
                    },
                    {
                        id: 'annuities',
                        label: 'Annuities, pensions, and retirement funds (i.e. IRA, 401K)',
                        val: false
                    },
                    {
                        id: 'insurance',
                        label: 'Insurance policies, disability, death benefits, or similar types of periodic receipts',
                        val: false
                    },
                    {
                        id: 'alimony',
                        label: 'Alimony or child support',
                        val: false
                    },
                    {
                        id: 'regular_contribution',
                        label: 'Regular contributions or gifts received from organizations or other persons not residing in the dwelling (including online donations such as GoFundMe or through a local bank)',
                        val: false
                    },
                    {
                        id: 'tanf',
                        label: 'Temporary Assistance for Needy Families (TANF)',
                        val: false
                    },
                    {
                        id: 'all_regular_pay',
                        label: 'All regular pay, special pay, and allowances of a member of the Armed Forces, except the special pay to a family member serving in the Armed Forces who is exposed to hostile fire (e.g., in the past, special pay included Operation Desert Storm)',
                        val: false
                    },
                    {
                        id: 'other_source',
                        label: 'Any other source (if yes, explain)',
                        val: false
                    },
                ],
            }
        },
        components: {
            Signatures,
            PrintableSignature,
            BlankPage, AttachedDocuments, ReviewResults, HeaderRow, ApplicantIncome, ApplicantData},
        computed: {
            ...mapState('Application', {
                application: 'application',
                applicant: 'applicant',
            }),
            
            ...mapGetters('Application', [ 'program', 'programSettings' ]),

            fullName() {
                return this.member.first_name + ' ' + this.member.last_name
            },

            propertyAddress() {
                let result = ''
                if (this.applicant.property_address)
                {
                    result = `${this.applicant.property_address.line_1} ${this.applicant.property_address.line_2}, ${this.applicant.property_address.city}, ${this.applicant.property_address.state}, ${this.applicant.property_address.zip}`
                }
                return result
            }
        },
    }
</script>
